import { render, staticRenderFns } from "./standardpage.vue?vue&type=template&id=6d4d7621&scoped=true&"
import script from "./standardpage.vue?vue&type=script&lang=js&"
export * from "./standardpage.vue?vue&type=script&lang=js&"
import style0 from "./standardpage.vue?vue&type=style&index=0&id=6d4d7621&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d7621",
  null
  
)

export default component.exports